// Card independiente para solicitar visitas a la propiedad

import React from 'react';
import { Calendar } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * Card para solicitar visita a la propiedad
 * Componente independiente que puede moverse a cualquier posición del layout
 *
 * @param {function} onScheduleVisit - Callback al hacer click en solicitar visita
 */
export const ScheduleVisitCard = ({ onScheduleVisit }) => {
  const { t } = useTranslation();
  return (
    <div className="bg-gradient-to-br from-amber-500/10 to-orange-600/10 backdrop-blur-xl rounded-xl p-4 border border-amber-500/20">
      <div className="flex items-center gap-3 mb-3">
        <div className="bg-amber-500/20 p-2 rounded-lg">
          <Calendar className="w-5 h-5 text-amber-400" />
        </div>
        <h3 className="text-sm font-semibold text-white">{t('visit.cardTitle')}</h3>
      </div>
      <p className="text-xs text-slate-300 mb-3">
        {t('visit.cardDesc')}
      </p>
      <button
        onClick={onScheduleVisit}
        className="w-full bg-gradient-to-r from-amber-500 to-orange-600 text-white font-semibold py-2.5 rounded-lg hover:from-amber-600 hover:to-orange-700 transition-all flex items-center justify-center gap-2 text-sm"
      >
        <Calendar className="w-4 h-4" />
        {t('visit.requestButton')}
      </button>
    </div>
  );
};

export default ScheduleVisitCard;
